<form [formGroup]="form" appearance="standard">
    <mat-checkbox [formControlName]="inputName" color="primary">{{label}}</mat-checkbox>
</form>